import { CommissionCase, CommissionType } from './types'

export const money = (value: number) =>
  new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: 'COP',
    maximumFractionDigits: 0
  }).format(value || 0)

export const typeLabel: Record<CommissionType, string> = {
  office: '3% Oficina',
  success: '2% Éxito',
  timely_payment: '1% Recaudo'
}

export const moveMonth = (period: string, amount: number) => {
  const [year, month] = period.split('-').map(Number)
  const value = new Date(Date.UTC(year, month - 1 + amount, 1))
  return `${value.getUTCFullYear()}-${String(value.getUTCMonth() + 1).padStart(2, '0')}`
}

export const currentPeriod = () => {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'America/Bogota',
    year: 'numeric',
    month: '2-digit'
  })
    .format(new Date())
    .split('-')
  return `${parts[0]}-${parts[1]}`
}

export const conceptKey = (personId: string, type: CommissionType) => `${personId}:${type}`

export const selectableConceptKeys = (rows: CommissionCase[]) => {
  const keys = new Set<string>()
  rows.forEach(row =>
    Object.values(row.concepts).forEach(concept => {
      if (concept.state === 'pending' && concept.selectable) keys.add(conceptKey(row.id, concept.type))
    })
  )
  return keys
}

export const selectedConceptTotal = (rows: CommissionCase[], selected: Set<string>) =>
  rows.reduce(
    (total, row) =>
      total +
      Object.values(row.concepts).reduce(
        (rowTotal, concept) =>
          concept.state === 'pending' && concept.selectable && selected.has(conceptKey(row.id, concept.type))
            ? rowTotal + concept.amount
            : rowTotal,
        0
      ),
    0
  )

export const conceptAuditLabel = (eventDate?: string, eventPeriod?: string, officePeriod?: string) => {
  const details = [
    eventDate ? `Evento: ${eventDate}` : '',
    eventPeriod ? `Mes del evento: ${eventPeriod}` : '',
    officePeriod ? `Período de oficina: ${officePeriod}` : ''
  ].filter(Boolean)
  return details.join(' · ')
}
